import React from 'react';
import { useFormContext } from 'react-hook-form';

import { usePreloadImages } from '../../hooks/usePreloadImages';
import { LayoutDataType } from '../../types';

import { ScreenAge as ScreenAgeFemale } from './Female';
import { ScreenAge as ScreenAgeMale } from './Male';

export const ScreenAge: React.FC = () => {
  usePreloadImages();

  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenAgeMale />;
  }

  return <ScreenAgeFemale />;
};
